import * as angular from 'angular';
import { SharedRegentsPrepStepComponentsModule } from './../../../shared-components/shared-regents-prep-step-components.module';
import { RegentsExamsStepperComponent } from './regents-exams-stepper.component';
import { StudentReviewComponent } from './steps/student-review/student-review.component';

export const RegentsExamsStepperModule = angular
  .module('regentsExamsStepperModule', [SharedRegentsPrepStepComponentsModule])
  .component('regentsExamsStepperComponent', RegentsExamsStepperComponent)
  .component('studentReviewComponent', StudentReviewComponent).name;
